export function clearDeviceFlowCodeCookie() {
    document.cookie = 'device_flow_code_response=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure'
}
